<template>
  <!--
    	作者：GM.RJ
    	时间：2020-11-28
    	描述：产品评价-添加
    -->
  <div class="comment-add">
    <el-dialog title="添加评价" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form size="small" :model="form" :rules="formRules" ref="form">

        <el-form-item label="评价评分" prop="score" :label-width="formLabelWidth">
          <el-radio-group v-model="form.score">
            <el-radio :label="5">5分</el-radio>
            <el-radio :label="4">4分</el-radio>
            <el-radio :label="3">3分</el-radio>
            <el-radio :label="2">2分</el-radio>
            <el-radio :label="1">1分</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户类型" prop="user_type" :label-width="formLabelWidth">
          <el-radio-group v-model="form.user_type">
            <el-radio :label="10">真实用户</el-radio>
            <el-radio :label="20">虚拟用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择用户" prop="user_id" :rules="[{ required: true, message: '请选择用户' }]" :label-width="formLabelWidth" v-if="form.user_type == 10">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" @click="openUserDialog">选择1位用户</el-button>
            <div v-if="form.user_id" class="img">
              <img :src="user.avatarUrl" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" :rules="[{ required: true, message: '请选择头像' }]" label="发布人头像" v-if="form.user_type == 20">
          <div>
            <el-button type="primary" @click="avatarUpload">上传图片</el-button>
            <img :src="path" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
            <!--上传图片组件-->
            <Upload v-if="isuploada" :isupload="isuploada" @returnImgs="returnAvatarImgsFunc">上传图片</Upload>
          </div>
        </el-form-item>

        <el-form-item label="发布人昵称" prop="nickName" :label-width="formLabelWidth"  v-if="form.user_type == 20">
          <el-input v-model="form.nickName" placeholder="请输入发布人昵称" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="选择产品" :rules="[{ required: true, message: '请选择产品' }]" prop="product_id" :label-width="formLabelWidth">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" @click="openProductDialog">选择1款产品</el-button>
            <div v-if="form.product_id" class="img">
              <img :src="product.product_image" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item>

        <el-form-item label="评价内容" prop="content" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="3" v-model="form.content" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="评价图片" prop="imgs" :label-width="formLabelWidth">
          <el-row>
            <el-tooltip effect="dark" content="建议尺寸750x750" placement="top">
              <el-button type="primary" icon="el-icon-plus" @click="openUpload">选择评价图片</el-button>
            </el-tooltip>
            <div v-if="form.imgs" class="img">
              <img :src="item.file_path" width="100" height="100" v-for="(item,index) in form.imgs" :key="index" />
            </div>
          </el-row>
        </el-form-item>

        <el-form-item label="分类排序" prop="sort" :label-width="formLabelWidth">
          <el-input v-model.number="form.sort" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="审核" prop="status" :label-width="formLabelWidth">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">待审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="添加时间" prop="create_time" :label-width="formLabelWidth">
          <el-date-picker
          v-model="form.create_time"
          type="datetime"
          value-format="timestamp"
          placeholder="选择添加时间">
        </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="addComment" :loading="loading">确 定</el-button>
      </div>

    </el-dialog>

    <!--上传图片组件-->
    <Upload v-if="isupload" :config="{ total: 9 }" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--用户选择-->
    <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>

    <!--商品选择-->
    <Product :isproduct="open_product" :excludeIds="excludeIds" :islist="true" @closeDialog="closeProductDialog"></Product>

  </div>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  import Product from '@/components/product/Product.vue';
  export default {
    components: {
      Upload,
      GetUser,
      Product
    },
    data() {
      return {
        user: {},
        product: {},
        /*是否打开添加弹窗*/
        open_user: false,
        /*是否打开选择商品*/
        open_product: false,
        form: {
          product_id: 0,
          user_id: 0,
          content: '',
          score: 10,
          status: 1,
          sort: 100,
          imgs: [],
          create_time: '',
          user_type:10,
          avatar:0,
          nickName:''
          // image_id: ''
        },

        excludeIds:'',
        // imgs: [],
        formRules: {
          product_id: [{
            required: true,
            message: '请输入产品id',
            trigger: 'blur'
          }],
          user_id: [{
            required: true,
            message: '请输入用户id',
            trigger: 'blur'
          }],
          content: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }],
          sort: [{
            required: true,
            message: '分类排序不能为空'
          }, {
            type: 'number',
            message: '分类排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
        isuploada:false,
        isImg:false,
        path:''
      };
    },
    props: ['open_add', 'addform'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*添加评价*/
      addComment() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PorductApi.addComment(params).then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        this.form.imgs = e;
        this.isupload = false;
      },


      /*上传*/
      avatarUpload() {
        this.isuploada = true;
      },
      /*获取图片*/
      returnAvatarImgsFunc(e) {
        let self = this;
        if (e != null) {
          this.form.avatar = e[0].file_id;
          this.path = e[0].file_path;
          this.isImg = true;
        }
        this.isuploada = false;
      },
      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },

      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },

      /*添加商品*/
      openProductDialog() {
        this.open_product = true;
      },

      /*关闭产品弹窗*/
      closeProductDialog(e) {
        console.log(e);
        if (e.type != 'error') {
          this.product = e.params[0];
          this.form.product_id = e.params[0].product_id;
        }
        this.open_product = false;
      },


    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
    display: flex;
  }
  .img img {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/comment/Add.vue